module.exports = __webpack_public_path__ + "static/media/utensil-fork.c1d6c093.svg";